<template>
  <div class="c-productContent" :style="{backgroundColor: content.bgColor}">
    <div class="c-standard">
      <h3 class="title_h3" v-show="content.title">{{ content.title }}</h3>
      <div class="c-productContent__content">
        <div class="c-productContent__left">
          <div v-for="(item, index) in content.left" class='c-productContent__blocks'>
            <h4 class="title_h4" v-show="item.title">{{ item.title }}</h4>
            <div v-for="(n, i) in item.content" :key="i">
              <p v-if="n.type=='text'" class="c-productContent__text">{{ n.content }}</p>
              <ul v-else-if="n.type=='list'" class="c-productContent__list">
                <li v-for='(x, y) in n.content' :key='y'>{{ x }}</li>
              </ul>
              <img v-else-if="n.type=='img'" class="c-productContent__img" :src="n.img">
              <div v-else-if="n.type=='block'" class="c-productContent__block">
                <div v-for="(a, b) in n.content" :key="b">
                  <img :src="a.img" alt="">
                  <h5>{{ a.title }}</h5>
                  <p>{{ a.content }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="c-productContent__right">
          <div v-for="(item, index) in content.right" class='c-productContent__blocks'>
            <h4 class="title_h4" v-show="item.title">{{ item.title }}</h4>
            <div v-for="(n, i) in item.content" :key="i">
              <p v-if="n.type=='text'" class="c-productContent__text">{{ n.content }}</p>
              <ul v-else-if="n.type=='list'" class="c-productContent__list">
                <li v-for='(x, y) in n.content' :key='y'>{{ x }}</li>
              </ul>
              <img v-else-if="n.type=='img'" class="c-productContent__img" :src="n.img">
              <div v-else-if="n.type=='block'" class="c-productContent__block">
                <div v-for="(a, b) in n.content" :key="b">
                  <img :src="a.img" alt="">
                  <h5>{{ a.title }}</h5>
                  <p>{{ a.content }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="c-productContent__midd">
        <div v-for="(item, index) in content.midd" class='c-productContent__blocks'>
          <h4 class="title_h4" v-show="item.title">{{ item.title }}</h4>
          <div v-for="(n, i) in item.content" :key="i">
            <p v-if="n.type=='text'" class="c-productContent__text">{{ n.content }}</p>
            <ul v-else-if="n.type=='list'" class="c-productContent__list">
              <li v-for='(x, y) in n.content' :key='y'>{{ x }}</li>
            </ul>
            <img v-else-if="n.type=='img'" class="c-productContent__img" :src="n.img">
            <div v-else-if="n.type=='block'" class="c-productContent__block">
              <div v-for="(a, b) in n.content" :key="b">
                <img :src="a.img" alt="">
                <h5>{{ a.title }}</h5>
                <p>{{ a.content }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'productContent',
    props: ['content'],
    data(){
      return{

      }
    },
    computed: {

    },
    methods:{

    },
    created(){

    }
  }
</script>

<style>


</style>
